export default __webpack_public_path__ + "static/media/DesktopImageItem3.83b95840.png";